import { render, staticRenderFns } from "./queueManagement.vue?vue&type=template&id=6d842f9f&"
import script from "./queueManagement.vue?vue&type=script&lang=js&"
export * from "./queueManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports